import { accounting } from 'accounting'

export const unformat = (value) => {
  if (!value) return value

  return accounting.unformat(value)
}

export const formatPrice = (value, precision = value % 1 === 0 ? 0 : 2) => {
  // eslint-disable-next-line no-restricted-globals
  if (isNaN(value)) return value

  return accounting.formatMoney(unformat(value), { precision })
}

export const formatPriceAsNumber = (
  value,
  precision = value % 1 === 0 ? 0 : 2
) => {
  // eslint-disable-next-line no-restricted-globals
  if (isNaN(value)) return value

  return accounting.formatNumber(unformat(value), { precision })
}

export const numberBetween = (min, max) => (value, previousValue) => {
  const parsedVal = parseFloat(value)
  return parsedVal >= min && parsedVal <= max ? value : previousValue
}
